import React, { useState, useRef, useContext, useEffect } from "react";
import Lottie from "lottie-web";
import MyContext from "../../../../context/MyContext";
import AuthContext from "../../../../context/userAuth.context";
import TickerContext from "../../../../context/ticker";
import swal from "sweetalert";
import axios from "axios";
const MiniCanv = (props) => {
  const { authenticationData } = useContext(AuthContext);

  const { Goto, setGoto, TickerPosition } =
    useContext(TickerContext);

  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    setCharacterData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    setChangeCount,
    calculateWidthByDuration,
    ChangeCount,
    Tl_TotalTime,
    seteditableObject,
  } = useContext(MyContext);

  var cName = props.obj.Name + "mini";

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  useEffect(() => {
    return () => {
      Lottie.destroy(cName);
    };
  }, []);

  const playref = useRef(null);

  const imgref = useRef(null);

  const [PlayCharacter, setPlayCharacter] = useState(false);

  const [delayHandler, setDelayHandler] = useState(null);

  const [delayHandler2, setDelayHandler2] = useState(null);

  const [GestureImage, setGestureImage] = useState(
    authenticationData.ApiBaseURL + "/" + props.obj.MiniImg
  );

  const PlayByPath = (path, name) => {
    try {
      if (!PlayCharacter) {
        //const ctx = playref.current.getContext('2d');
        Lottie.loadAnimation({
          container: playref.current,
          name: cName,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: authenticationData.ApiBaseURL + "/" + path,
          rendererSettings: {
            preserveAspectRatio: "xMidYMin meet",
            viewBoxOnly: true,
            progressiveLoad: true,
          },
        });
        setPlayCharacter(true);
        playref.current.style.display = "block";
        imgref.current.style.display = "none";
      } else {
        Lottie.play(cName);
        playref.current.style.display = "block";
        imgref.current.style.display = "none";
      }
    } catch {}
  };

  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      var xml = new XMLSerializer().serializeToString(svg);
      if (xml) {
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.src = image64;
      } else {
        reject();
      }
    });
  }

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  const mouseleave = async () => {
    clearTimeout(delayHandler);
    clearTimeout(delayHandler2);
    if (PlayCharacter) {
      Lottie.stop(cName);
    }
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  // My Characters: delete one of the user's own characters. The list lives in the wrapper
  // (assetsCharacterWrapper), which removes the card through props.onDeleted.
  const deleteUserCharacter = (characterID) => {
    swal({
      title: "Are you sure you want to delete.",
      text: "This character will be deleted permanently.",
      icon: "warning",
      buttons: [true, "Yes, Delete"],
      dangerMode: true,
    }).then((result) => {
      if (!result) return;
      const auth = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token") || "null");
      const formData = new FormData();
      formData.append("id", characterID);
      axios
        .post(authenticationData.ApiBaseURL + `/api/Character/DeleteUserCharacter`, formData, {
          headers: auth ? { Authorization: "Bearer " + auth.access_token } : {},
        })
        .then((response) => {
          if (!response.data || response.data.status === false) {
            swal("Not deleted", (response.data && response.data.message) || "This character could not be deleted.", "error");
            return;
          }
          try {
            Lottie.destroy(cName);
          } catch (e) {
            /* not playing */
          }
          if (props.onDeleted) props.onDeleted(characterID);
          swal("Success", "Character deleted successfully.", "success");
        })
        .catch(() => {
          swal("Error", "Something went wrong. Please contact support for assistance.", "error");
        });
    });
  };

  const addCharacter = async (event) => {
    if (
      event.target.id === "actions" ||
      event.target.id === "upload" ||
      event.target.offsetParent.id === "upload" ||
      event.target.id === "delete" ||
      event.target.offsetParent.id == "delete"
    ) {
      return null;
    }

    // debugger
    if (PlayCharacter) {
      Lottie.stop(cName);
    }
    let gImage = GestureImage;
    if (!gImage) {
      console.log('playref.current.firstChild', playref.current.firstChild)
      // let img = await loadCharacter(playref.current.firstChild);
      let can = document.createElement("canvas");
      can.width = img.width * 3;
      can.height = img.height * 3;
      const ctx = can.getContext("2d");
      ctx.drawImage(img, 0, 0);
      setGestureImage(can.toDataURL("image/png"));
      gImage = can.toDataURL("image/png");
    }
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let widthPercentage = 350 / CanvasWidth;
    let heightPercentage = 440 / canvasHeight;
    let _width = (CanvasWidth * widthPercentage) / 2;
    let _height = (canvasHeight * heightPercentage) / 2;

    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);
    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
    if (Goto.innerMenu == "Char") {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === Goto.key) {
          Lottie.destroy(array[i].AnimationId);
          array[i].character_FilePath = props.obj.poses[0].poseFile;
          //array[i].character_Gender = gender;
          array[i].character_poses = props.obj.poses;
          array[i].ImageSrc = gImage;
          array[i].CharacterPlayed = false;
        }
      }
      setLayersData(array);
      setChangeCount(ChangeCount + 1);
      setGoto({
        menu: null,
        innerMenu: null,
        key: null,
      });
    } else {
      var topIndex = 0;
      if (LayersData.length > 0) {
        topIndex = LayersData[LayersData.length - 1].layerIndex;
        topIndex = topIndex + 1;
      }
      var typelength = 1;
      var checkKey = 0;
      for (var i = 0; i < LayersData.length; i++) {
        if (LayersData[i].Editable === true) {
          LayersData[i].Editable = false;
          LayersData[i].showDiv = false;
        }
        LayersData[i].toolbar = false;
        if (LayersData[i].type === "Character") {
          typelength = typelength + 1;
        }
        if (LayersData[i].key >= checkKey) {
          checkKey = LayersData[i].key;
        }
      }
      let currentTime = calculateTimeByWidth(TickerPosition);
      let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);
      let newEntryLayerData = {
        AnimationId: makeid(7),
        key: checkKey + 1,
        type: "Character",
        bgColor: "#00adff",
        showDiv: true,
        Name: `Character-${typelength}`,
        canvas: null,
        userFile: "xyz",
        layerIndex: topIndex,
        index: null,
        TimelineZoom: timelineZoomVal,
        duration: totalTime,
        startTime: currentTime,
        endTime: calculateTimeByWidth(Tl_TotalTime.width),
        visible: true,
        OutEffect: "none",
        InEffect: "none",
        typeIcon: "person",
        character_poses: props.obj.poses,
        ImageSrc: props.obj.MiniImg,
        character_FilePath: props.obj.poses[0].poseFile, //with out .json
        startTransitionWidth: 0,
        startTransitionLeft: 0,
        endTransitionWidth: 0,
        endTransitionLeft: 0,
        x: left,
        y: top,
        opacity: 1,
        originalOpacity: 1,
        width: _width,
        height: _height,
        toolbar: true,
        FurtherSetting: false,
        lock: false,
        layerlock: false,
        opc: 1,
        hidden: false,
        Editable: true,
        CharacterStop: true,
        CharacterPause: false,
        CharacterPlayed: false,
        startPositionOnTimeline: 0,
        player: false,
        Animate: false,
        Added: true,
        flip: "scaleX(1)",
        rotateAngle: 0,
        AzData: null,
        startAtoZ: false,
        InMultiDrag: false,
        ImageFrame: 0,
        JSONValue: (async () => {
          const resp = await fetch(
            authenticationData.ApiBaseURL + "/" + props.obj.poses[0].poseFile
          );
          const jsonData = await resp.json();
          newEntryLayerData.JSONValue = jsonData;
          newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
            newEntryLayerData.duration
          );
          newEntryLayerData.endTransitionLeft =
            newEntryLayerData.widthOnTimeline -
            newEntryLayerData.endTransitionWidth;
          setLayersData(LayersData.concat(newEntryLayerData));
          seteditableObject({
            showPanel: true,
            editableItem: newEntryLayerData,
          });
          setChangeCount(ChangeCount + 1);
          return jsonData;
        })(),
      };
    }
  };

  const MouseOnChr = (event, poseList, FilePath, settings, gender, name) => {
    //if (!props.obj.MiniImg) { MultiSnapShot(poseList) }

    setDelayHandler(
      setTimeout(() => {
        PlayByPath(poseList[0].poseFile, name);
      }, 600)
    );
  };

  const showActions = (event, poseList, FilePath, settings, gender, name) => {
    if (event.target.id == "actions") {
      var offsets = event.target.getBoundingClientRect();
      var leftside = Math.round(offsets.x + offsets.width);
      var topside = Math.round(offsets.y);

      let ChangePose = false;
      let prvKey = null;

      setDelayHandler2(
        setTimeout(() => {
          props.setChrPopData({ left: leftside, top: topside });
          setCharacterData({
            poseList,
            gender,
            name,
            FilePath,
            ChangePose,
            prvKey,
          });
          props.setchrPop(true);
        }, 400)
      );
    }
  };

  var AssetItem = {
    display: "block",
    backgroundPosition: "center center",

    textAlign: "center",
  };

  return (
    <div
      style={AssetItem}
      className="AssetItemforCharacter"
      onMouseLeave={() => mouseleave()}
      onClick={(event) => {
        if (PlayCharacter) {
          addCharacter(event);
        }
      }}
      onMouseEnter={(event) =>
        MouseOnChr(
          event,
          props.obj.poses,
          props.obj.FilePath,
          props.obj.settings,
          props.obj.gender,
          props.obj.Name
        )
      }
    >
      {/* <span>{props.obj.id}</span> */}
      {/* <canvas ref={playref} className='canv' width={100} height={100} style={{ display: 'none' }} /> */}

      <div
        ref={playref}
        className="canv"
        style={{
          width: "140px",
          height: "169px",
          display: "none",
          margin: "0 auto",
          pointerEvents: "none",
        }}
      />

      <img
        ref={imgref}
        src={authenticationData.ApiBaseURL + "/" + props.obj.MiniImg}
        alt=""
        style={{ width: "140px", height: "169px" }}
      />
      <div
        id="actions"
        onClick={(event) =>
          showActions(
            event,
            props.obj.poses,
            props.obj.FilePath,
            props.obj.settings,
            props.obj.gender,
            props.obj.Name
          )
        }
        className="showActions"
        title="Admin Gesture Upload"
      >
        Actions
      </div>
      {props.ActiveTab == "MyCharacters" && (
        <>
          <div
            id="delete"
            className="userIconsDelete"
            title="Delete character"
            onClick={(event) => {
              event.stopPropagation();
              deleteUserCharacter(props.obj.id);
            }}
          >
            <span
              className="material-icons"
              style={{ fontSize: "14px", lineHeight: "12px" }}
            >
              delete
            </span>
          </div>
        </>
      )}
    </div>
  );
};
export default MiniCanv;
